import { Field, Item, LinkField, Text, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps } from 'lib/ComponentProps';

import { mapFilterGroup } from 'src/mappers/models/filterGroupMapper';
import { mapResourceListItem } from 'src/mappers/models/resouceListItemMapper';

import { ExtendedItem } from 'src/types/ExtendedItem';
import { ResourceListItem } from 'src/types/ResourceListItem';
import { SocialSharingOptions } from 'src/types/SocialSharingOptions';

import { Listing, PinnedItem } from '../_Listing/_Listing';

import styles from './CuratedListing.module.css';

type CuratedListingProps = ComponentProps & {
	fields: {
		Advert: ComponentProps & {
			fields: Item & {
				Title: Field<string>;
				NarrowId: Field<string>;
				WideId: Field<string>;
			};
		};
		Title: Field<string>;
		Items: ExtendedItem[];
		PinnedCardTitle: Field<string>;
		PinnedCardDescription: Field<string>;
		PinnedCardLink: LinkField;
		WildCardConfig: ExtendedItem & {
			fields: {
				SearchListingWildcardPage: LinkField;
			};
		};
		FilterGroups: ExtendedItem[];
		FavouriteButtonText: Field<string>;
		UnfavouriteText: Field<string>;
		Theme: {
			name: string;
		};
		RegisteredUserText: Field<string>;
		RCNMemberText: Field<string>;
		RCNiPlusSubscriberText: Field<string>;
		OrganisationalProductText: Field<string>;
		OpenAccessText: Field<string>;
		CPDHoursText: Field<string>;
		SubjectLinkPrependedText: Field<string>;
		ShareButtonToolTip: Field<string>;
		ShareOptions: SocialSharingOptions;
		NoShareOptions: Field<string>;
	};
};

export default withDatasourceCheck()<CuratedListingProps>(CuratedListing);

function CuratedListing(props: CuratedListingProps): JSX.Element {
	const curatedList = Array<ResourceListItem>();
	if (props.fields.Items?.length) {
		props.fields.Items.map((item) => {
			const resourceListItem = mapResourceListItem(item, props.fields.WildCardConfig?.fields?.SearchListingWildcardPage?.value?.href);
			if (resourceListItem) {
				curatedList.push(resourceListItem);
			}
		});
	}

	const filterGroups = mapFilterGroup(props.fields.FilterGroups);

	const pinnedItem: PinnedItem = {
		Title: props.fields.PinnedCardTitle,
		Description: props.fields.PinnedCardDescription,
		Link: props.fields.PinnedCardLink,
	};

	const themeColour = props.fields.Theme;

	return (
		<section className={`${themeColour ? themeColour.name : ''} padYL maxWidth`}>
			<Text tag="h2" field={props.fields.Title} className={themeColour ? ` ${styles.title}` : ''} />
			<Listing
				items={curatedList}
				pinnedItem={pinnedItem}
				Advert={props.fields.Advert}
				filters={filterGroups}
				wildCardUrl={props.fields.WildCardConfig?.fields?.SearchListingWildcardPage?.value?.href}
				favouriteButtonText={props.fields.FavouriteButtonText}
				unfavouriteText={props.fields.UnfavouriteText}
				registeredUserText={props.fields.RegisteredUserText}
				rcnMemberText={props.fields.RCNMemberText}
				rcniPlusSubscriberText={props.fields.RCNiPlusSubscriberText}
				organisationalProductText={props.fields.OrganisationalProductText}
				openAccessText={props.fields.OpenAccessText}
				subjectLinkPrependedText={props.fields.SubjectLinkPrependedText}
				shareButtonToolTip={props.fields.ShareButtonToolTip}
				shareOptions={props.fields.ShareOptions}
				noShareOptions={props.fields.NoShareOptions}
				cpdHoursText={props.fields.CPDHoursText}
			/>
		</section>
	);
}
